'use strict';

var MappedFaresInversionTransformerFactory = function MappedFaresInversionTransformerFactory(DataTransformer, momentService) {
  function MappedFaresInversionTransformer() {
    DataTransformer.call(this);
    this.sourceType = ['mapped-fares-inversion-mode'];
    this.targetType = ['mapped-fares-inversion'];
    this.priority = 1;
  }
  MappedFaresInversionTransformer.prototype = Object.create(DataTransformer.prototype);
  MappedFaresInversionTransformer.constructor = MappedFaresInversionTransformer;
  MappedFaresInversionTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType.indexOf(targetType) !== -1;
  };
  MappedFaresInversionTransformer.prototype.isCacheable = function () {
    return false;
  };
  MappedFaresInversionTransformer.prototype.getCacheKey = function () {
    return this.sourceType.join('-') + '-' + this.targetType.join('-');
  };
  MappedFaresInversionTransformer.prototype.transform = function (data) {
    var results = data.domain.results;
    var finalResult = [];
    for (var index = 0, dataLength = results.length; index < dataLength; index++) {
      var element = results[index];
      element.market = element.marketOrigin + '-' + element.marketDestination;
      element.applicableDateRangeBegin = momentService.of(element.applicableDateRangeBegin, momentService.FIELD.APPLICABLE_DATE_RANGE);
      element.applicableDateRangeEnd = momentService.of(element.applicableDateRangeEnd, momentService.FIELD.APPLICABLE_DATE_RANGE);
      finalResult.push(element);
    }
    return finalResult;
  };
  return MappedFaresInversionTransformer;
};
MappedFaresInversionTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = MappedFaresInversionTransformerFactory;